module.exports = __webpack_public_path__ + "img/polish@2x.f2ba439.jpg";